import { render } from "./HeroiconsSolidLocationMarker.vue?vue&type=template&id=390a8934"
const script = {}

import exportComponent from "C:\\laragon\\www\\bipay-payg\\vendor\\laravel\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidLocationMarker.vue"]])

export default __exports__